// extracted by mini-css-extract-plugin
export default {"container":"coi_GA4fL","topCoin":"coi_top_2JOPl","coin-sway":"coi_coi_WLIhc"};